<template>
  <div v-if="eventRules.length">
    <!-- EVENT CONDITIONS -->
    <div class="mx-1 py-0" >
      <hr />
    </div>
    <div class="media section-margin py-0" >
      <div class="content is-size-14px">
        <h3
          class="mt-0  is-section-headline"
        >{{ $t('ui.eventRules')}}</h3>
        <ul class="mt-half">
          <li v-for="cond in eventRulesList" :key="cond.id">{{ cond.value.tr }}</li>
          <div
            class="has-text-link is-inline-block  mt-half cursor-pointer"
            @click="isHidden = !isHidden"
            v-if="eventRules.length > 3"
          >
            {{ isHidden ? $t('ui.seeAll') : $t('ui.hide') }}
            <span class="icon is-small">
              <i class="mdi mdi-chevron-down mdi-16px" :class="{ 'mdi-chevron-up': !isHidden }"></i>
            </span>
          </div>
        </ul>
      </div>
    </div>
    <!-- ./EVENT CONDITIONS -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    eventRules: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      isHidden: true
    };
  },
  computed: {
    eventRulesList() {
      if (this.isHidden) {
        return this.eventRules.slice(0, 3);
      } else {
        return this.eventRules;
      }
    }
  }
};
</script>

<style>
</style>